import { ContractingTable } from '../components/guestProfileContractingTab/documentsTable/ContractingTable';

export const GuestProfileContractingTab = ({ customerId }: { customerId: string }) => {
    return <ContractingTable customerId={customerId} />;
};
